var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-y-transition","mode":"out-in"}},[(_vm.loaded && _vm.event)?_c('InputOutputContainer'):_c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"width":"100%","height":"100%"}},[_c('v-progress-circular',{attrs:{"size":80,"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }